import React from "react";
import { BoxLoadingContainer } from "./style";

export const BoxLoading = (props) => {
  return (
    <BoxLoadingContainer size={props && props.size}>
      <div className="spinner">
        <div className="double-bounce1" />
        <div className="double-bounce2" />
      </div>
    </BoxLoadingContainer>
  );
};
